import { RoomType } from "../../../api/listings-client";

interface AccommodationTypeStepProps {
    roomType: RoomType | null;
    setRoomType: (type: RoomType) => void;
}

const AccommodationTypeStep: React.FC<AccommodationTypeStepProps> = ({ 
    roomType,
    setRoomType 
}) => {
    const buttonClasses = (type: RoomType) =>
        `text-start bg-gradient-to-br from-[#24ccf2]/0 via-[#2476f2]/0 to-purple-500/0 hover:from-[#24ccf2]/10 hover:via-[#2476f2]/10 hover:to-purple-500/10 p-4 md:p-5 rounded-xl border ${
            roomType === type
                ? 'bg-white shadow-md border-gray-200 text-[#2476f2]'
                : 'text-gray-800 border-transparent'
        }`;

    return (
        <div className="py-24">
            <h1 className="block text-2xl font-bold text-gray-800 sm:text-4xl mb-10">
                What type of room are you listing?
            </h1>
            <div className="mb-10 lg:mb-0 max-w-[800px] justify-center m-auto">
                <nav className="grid gap-4">
                    <button
                        type="button"
                        className={buttonClasses(RoomType.OWN)}
                        onClick={() => setRoomType(RoomType.OWN)}
                    >
                        <span className="flex">
                            <svg
                                className="flex-shrink-0 mt-2 size-6 md:size-7"
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path d="M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z" />
                                <path d="M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z" />
                                <path d="M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z" />
                                <path d="M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z" />
                                <path d="M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z" />
                            </svg>
                            <span className="grow ms-6">
                                <span className="block text-lg font-semibold">Full room</span>
                                <span className="block mt-1">
                                    Tenants have their own room to themselves. Facilities may or may not be shared.
                                </span>
                            </span>
                        </span>
                    </button>
                    <button
                        type="button"
                        className={buttonClasses(RoomType.SHARED)}
                        onClick={() => setRoomType(RoomType.SHARED)}
                    >
                        <span className="flex">
                            <svg
                                className="flex-shrink-0 mt-2 size-6 md:size-7"
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path d="m12 14 4-4" />
                                <path d="M3.34 19a10 10 0 1 1 17.32 0" />
                            </svg>
                            <span className="grow ms-6">
                                <span className="block text-lg font-semibold">Shared room</span>
                                <span className="block mt-1">
                                    Tenants sleep in a room that may be shared with you or others.
                                </span>
                            </span>
                        </span>
                    </button>
                </nav>
            </div>
        </div>
    );
};

export default AccommodationTypeStep;